import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import allMethods from "../src/assets/allMethods";

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$allMethods =allMethods
Vue.prototype.$http = axios
// 关闭 点击遮罩关闭弹出层 功能
ElementUI.Dialog.props.closeOnClickModal.default = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
